import apiClient from 'utilities/apiClient';

export const get_my_tasks = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.plans}/${url}`, payload, true);
};
export const update_task_status = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.plans}/${url}`, payload, true);
};
